const handleAuthError = error => {
  // '/v1/auth' é compartilhado por LOGIN (POST) e LOGOUT (DELETE) — o método precisa entrar
  // na checagem, senão o caso especial abaixo (hasActiveSession) fica alcançável também pela
  // chamada de logout (mesma URL), o que nunca foi a intenção.
  if (error?.config?.url === '/v1/auth' && error?.config?.method?.toLowerCase() === 'post') {
    // 401 com hasActiveSession:true não é falha de credencial — é "já logado em outro lugar"
    // (`There is an active session for this user on this platform!`). Login/index.js trata esse
    // caso dentro do try (checa response.status/data.hasActiveSession) pra abrir o modal "Acesso
    // exclusivo por login" com o botão que reenvia com expireCurrentSession:true. Rejeitar sempre
    // (como antes) manda esse 401 pro catch genérico, que mostra a mensagem errada ("rede com
    // dificuldade") e nunca deixa o usuário forçar o login. Resolver só este caso restaura o fluxo;
    // qualquer outro erro (senha errada, 5xx, rede) continua rejeitando normalmente.
    if (error?.response?.status === 401 && error?.response?.data?.hasActiveSession) {
      return Promise.resolve(error.response);
    }
    // Rejeita com `error` (nunca undefined), não `error.response` — em erro de rede (sem
    // resposta do servidor) `error.response` é undefined, e isso derrubava o próximo
    // interceptor da cadeia (addSentryLogginInterceptor), que desestrutura `error` e
    // quebrava com "undefined is not an object (evaluating 'e.config')" como unhandled
    // rejection. Login/index.js só usa o catch genericamente, sem ler .status/.data daqui.
    return Promise.reject(error);
  }
  if (error?.response?.status !== 401) {
    return Promise.reject(error);
  } else {
    return Promise.reject(error);
  }
};

export { handleAuthError };
